import {
  TTranslationAppearanceForm,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  locale: {
    label: 'Jazyk',
    tooltip: 'Umožňuje vybrať požadovaný jazyk a regionálne nastavenia používateľského rozhrania.',
  },
  fontSize: {
    label: 'Škálovanie stránky',
    tooltip: 'Umožňuje nastaviť veľkosť písma a prvkov používateľského rozhrania.',
  },
  chartTimeFormat: {
    label: 'Formát času grafu',
    tooltip: 'Určuje spôsob zobrazovania dátumov a časových pečiatok na osi X grafov.',
  },
  unitSystem: {
    label: 'Sústava jednotiek',
    tooltip: 'Vyberte preferované merné jednotky (napr. metrické alebo imperiálne) na zobrazovanie hodnôt',
  },
  scaleOption: {
    label: 'Mierka rozloženia',
    tooltip: 'Určuje, ako sa má zobrazovať mierka rozloženia obchodu.',
  },
  showOnlyAvailableApps: {
    label: 'Skryť neaktívne aplikácie?',
    tooltip: 'Skryje aplikácie, ktoré nie sú k dispozícii, aby bolo používateľské rozhranie prehľadnejšie.',
  },
};

export default {
  subline: 'Zmeniť vzhľad Qmulus',
  appearanceForm,
};
